import { useI18n } from '../../i18n/useI18n.js'

import { PillBadge } from '../PillBadge/PillBadge.jsx'

import styles from './OfferBadge.module.scss'

/**
 * OfferBadge — offer status as a localized, styled inline badge.
 *
 * Uses the shared `--bim-data-value-size` CSS var for its font-size so that
 * it stays visually consistent with DataItem values when rendered in the
 * same tile context.
 *
 * The `size` prop injects `--bim-data-*` vars on the badge element itself,
 * so it can be sized independently of any ancestor DataGrid.
 *
 * @param {object}   props
 * @param {'tiny'|'small'|'normal'|'large'} [props.size] - Typography scale; omit to inherit from ancestor
 * @param {string}  [props.className]            - Extra class on root element
 */
export function OfferBadge({ size = 'small', className }) {
  const { t } = useI18n()

  return (
    <PillBadge
      value={t(`common.on_offer`)}
      size={size}
      className={[styles.offerBadge, className].filter(Boolean).join(' ')}
    />
  )
}
